// Per-list overrides for the sticky signup banner (AppPromoFooter) shown on
// locked/demo guest lists. Any list id not present here just keeps the
// generic `apppromo.general.*` copy - see List.vue.
//
// Each entry's list id comes from an env var (same pattern as
// LOCKED_LIST_IDS) because a given demo list has a different id per
// environment (dev/preprod vs production) - never hardcode a raw id here.
const entries = [
  {
    listId: process.env.LOCKED_LIST_BABY_NEEDS_BANNER_ID,
    title: "Convertir en tu lista personal",
    subtitle: "Podrás quitar cosas, añadir y compartir con tu familia.",
    ctaText: "Convertir",
    ctaRouteName: "landing-signup-baby-needs",
  },
];

export default entries.reduce((byListId, { listId, ...content }) => {
  if (listId) {
    byListId[listId] = content;
  }
  return byListId;
}, {});
